/*
* Table sort based on https://github.com/tofsjonas/sortable
* Copyleft 2017 Jonas Earendel
*/

document.addEventListener( 'click', function ( e ) {

	let down_class = ' sort-down ';
	let up_class = ' sort-up ';
	let regex_dir = / sort-(up|down) /;
	let regex_table = /\bTableSorter\b/;
	let get_data_attribute_name = 'data-sort';
	let th_element = e.target;
	let column_index;

	/**
	 * So google closure doesn't throw a fit over the sometimes empty dir argument
	 * @param {EventTarget} element
	 * @param  {string=} dir
	 * @return void
	 */
	function reclassify( element, dir ) {
		element.className = element.className.replace( regex_dir, '' ) + dir || '';
	}

	function getData( tr, func ) {
		const cell = tr.cells[ column_index ];
		if ( !cell.hasAttribute( get_data_attribute_name ) )
			cell.setAttribute( get_data_attribute_name, func.getData( cell ) );

		return cell.getAttribute( get_data_attribute_name );
	}

	// The "useMe" function returns true or false if its getData is to be used
	const get_data_functions = [
		{ // ID
			useMe: function () {
				return /\bid\b/.test( th_element.className );
			},
			getData: function ( cell ) {
				const firstLetter = cell.innerText.charAt(0),
					startsWithLetter = firstLetter === 'A' || firstLetter === 'B' || firstLetter === 'C' || firstLetter === 'D';

				return cell.innerText.replace('A',startsWithLetter ? '10' : '1').replace('B',startsWithLetter ? '1000' : '2').replace('C',startsWithLetter ? '100000' : '3').replace('D',startsWithLetter ? '10000000' : '4')
			},
		}, { // Plocha (m2)
			useMe: function () {
				return /\bplocha\b/.test( th_element.className );
			},
			getData: function ( cell ) {
				return cell.innerText.replace(/m2/,'').replace(/\//,'').replace(/\<sup\>2\<\/sup\>/,'').replace(/ /,'')
			},
		}, { // Dispozice
			useMe: function () {
				return /\bdispozice\b/.test( th_element.className );
			},
			getData: function ( cell ) {
				return cell.innerText.replace(/\+kk/,'0').replace(/\+1/,'1').replace(/garsoniéra/,'0');
			},
		}, { // Cena
			useMe: function () {
				return /\bcena\b/.test( th_element.className );
			},
			getData: function ( cell ) {
				return cell.innerText.replace(/Kč/,'').replace(/ /,'').replace(/ /,'').replace(/ /,'').replace(/\xA0/g,'');
			},
		}, { // default
			useMe: function () {
				return true;
			},
			getData: function ( cell ) {
				return cell.innerText;
			},
		},
	];

	if ( th_element.nodeName !== 'TH' )
		return;

	const table = th_element.parentNode.offsetParent;

	// make sure it is a sortable table
	if (!regex_table.test(table.className))
		return;

	const tr = th_element.parentNode;
	const nodes = tr.cells;

	// reset thead cells and get column index
	for ( let i = 0; i < nodes.length; i++ ) {
		if ( nodes[ i ] === th_element )
			column_index = i;
		else
			reclassify( nodes[ i ], '' );
	}

	let dir = down_class;

	// check if we're sorting up or down, and update the css accordingly
	if ( th_element.className.indexOf( down_class ) !== -1 )
		dir = up_class;

	reclassify( th_element, dir );

	// extract all table rows, so the sorting can start.
	let org_tbody = table.tBodies[ 0 ];

	// slightly faster if cloned, noticable for huge tables.
	let rows = [].slice.call( org_tbody.cloneNode( true ).rows, 0 );
	let reverse = ( dir === up_class );
	let get_data_func;

	for ( let i = 0; i < get_data_functions.length; i++ ) {
		get_data_func = get_data_functions[ i ];
		if ( get_data_func.useMe() ) break;
	}

	// sort them using custom built in array sort.
	rows.sort( function ( a, b ) {
		a = getData( a, get_data_func )
		b = getData( b, get_data_func )
		if ( reverse ) {
			let c = a;
			a = b;
			b = c;
		}
		// return func.compare( a, b );
		return isNaN( a - b ) ? a.localeCompare( b ) : a - b;
	} );

	// Make a clone without contents
	const clone_tbody = org_tbody.cloneNode();

	// Build a sorted table body and replace the old one.
	for ( let i = 0; i < rows.length; i++ )
		clone_tbody.appendChild( rows[ i ] );

	// And finally insert the end result
	table.replaceChild( clone_tbody, org_tbody );
});